import { DEFAULT_PROCESS_FLOW_WIDTH } from "../body/sidebar/flow/ElementUtils";

const DefaultWidths = {
  Letter: 52,
  Number: 52,
  Player: 160,
  Activity: 200,
  TrackType: 110,
  Default: 160,
  CornerHeadCell: 64,
  StyleCornerHeadCell: 100,
  Flow: DEFAULT_PROCESS_FLOW_WIDTH,
  Blank: 30,
  Header: 64,
  Show: 64,
  Size: 64,
  Grid: 90,
};
const DefaultHeights = {
  Player: 40,
  Letter: 40,
  Default: 36.4,
  Grid: 25,
};

const ActiveCorners = {
  NavigationCorner: 1,
  StyleCorner: 2,
};
export { DefaultWidths, ActiveCorners, DefaultHeights };
